
import Request from '@/services/request/index'

export const getList = (params) => {
  return Request.get({ url: "/system/information/page", params });
}
export const getDetail = (data) => {
  return Request.get({ url: "/system/information/get?id=" + data.id, });
}

